export default {
  createBusiness: {
    businessCreation: `Création de site`,
    smbBusinessCreation: "Création d'emplacement",
    businessCreationDetail: `Recherchez l'emplacement de votre entreprise par nom. Les emplacements les plus proches de vous afficheront en premier.`,
    smbBusinessCreationDetail: 'Définir un emplacement précis ou que vos postes seront situés.',
    businessName: `Nom du site`,
    businessId: `Identifiant de l'emplacement`,
    locationIdRequired: "L’identifiant de l'emplacement est requis",
    locationIdMaxLength: "L’identifiant de l'emplacement ne doit pas dépasser {{length}} caractères",
    locationIdDuplicate: "Cet identifiant de l'emplacement existe déjà dans votre compte",
    address: `Adresse`,
    city: `Ville`,
    state: `État / Province / Région`,
    zip: `ZIP / Code postal`,
    country: `Pays`,
    australia: 'Australia',
    canada: 'Canada',
    usa: 'USA',
    url: 'URL',
    phone: `Numéro de téléphone`,
    create: 'Créer',
    businessNameRequired: `Le nom de l'entreprise est requis`,
    cityNameRequired: `Le nom de la ville est requis`,
    addressRequired: `L'adresse de l'entreprise est requise`,
    countryRequired: 'Le pays est requis',
    zipRequired: 'Le ZIP ou code postal est requis',
    webSiteRequired: 'Le site Web est requis',
    websiteInvalid: 'Le site Web doit avoir un URL valide',
    stateRequired: `L'état ou la province ou la région est requise`,
    phoneRequired: `Le numéro de téléphone est requis`,
    phoneMin: `Le numéro de téléphone est requis`,
    latitudeRequired: 'La latitude est requise',
    longitudeRequired: 'La longitude est requise',
    placeIdRequired: 'Place Id  is required',
    positionRequired: 'Position  is required',
    viewBusinessList: 'Voir liste des sites',
    update: 'Mettre à jour',
    successMsg: 'Le site a été créé avec succès',
    successMsgBusinessUpdate: 'Le site a été mis à jour avec succès',
    businessAlreadyExists: 'Il existe déjà une entreprise à cet endroit dans AppyHere',
    group: 'Numéro de groupe',
    smbBusinessOnBoardingModal: {
      businessTitle: 'Quelle est la suite?',
      businessHeading: 'Création de votre emplacement',
      businessDesc:
        "Pour trouver les candidats les mieux situés pour travailler dans votre entreprise, nous avons besoin de plusieurs détails, comme l'adresse exacte de l'emplacement. Ceci serait l'adresse ou les candidats embauchés travailleront.",
      positionTitle: 'Quelle est la suite?',
      positionHeading: 'Création de votre poste',
      positionDesc:
        "Allons créer le poste pour lequel vos candidats vont postuler. Assurez-vous de garder les détails les plus précis possibles, pour être certain d'attirer les candidats idéals au poste.",
      of: 'de ',
      skip: 'Ignorer',
      next: 'Suivant',
    },
  },
  businessList: {
    searchBusiness: `Rechercher pas nom de l'emplacement ou son identifiant`,
    myLocations: `Mes sites`,
    allLocations: `Tous les sites`,
    business: 'Sites',
    create: 'Créer',
    listOfBusiness: `Liste des sites`,
    loadMore: ` Voir plus`,
    job: 'poste',
    jobs: 'postes',
    processingApplications: 'Masquer les postes inactifs',
    toolTipText: 'Active cette option pour afficher uniquement les emplacements qui recrutent activement.',
    openPositions: `Poste ouvert`,
    noBusinessCreated: `Pour créer des postes et voir des candidats, vous devez d'abord ajouter un site à l'entreprise.`,
    copiedMessage: 'Vous avez copié le lien pour cet emplacement.',
  },
  topCandidate: {
    appliedFilterLabels: {
      salary: 'Salaire',
      salaryRange: 'Échelle salariale',
      // otherFilterParams: 'Autres filtres',
      experienceInYears: 'Expérience',
      lastActivityInDays: 'Dernière activité',
      flexibleTransportation: 'Autres filtres',
    },
    filters: 'Filtres',
    appliedFilters: 'Filtres appliqués',
    resetFilters: 'Réinitialiser les filtres',
    applyBtn: 'Appliquer',
    salary: 'Salaire',
    withInRange: `À l'interieur de l'echelle salariale`,
    aboveRange: 'Au dessus de l`echelle salariale',
    salaryRange: 'Echelle salariale (taux horaire - $)',
    top: 'Sourçage',
    bookmarked: 'Sauvegardé',
    review: 'Révision',
    active: 'Actifs',
    searchCandidates: 'Rechercher parmis les candidats',
    minExperience: 'Expérience minimum (en années)',
    years: ' Années',
    lastActive: 'Dernière activité',
    lastActiveDays: 'Dernière activité (en jours)',
    reset: 'Réinitialiser',
    lessThanAWeek: `moins d'une semaine`,
    oneMonth: '1 mois',
    sixMonths: '6 mois',
    lessThanSixMonth: 'moins de 6 mois',
    oneYear: '1 an',
    sixYears: '6 ans',
    flexTransport: 'Accès à un transport flexible',
    seekerIsStudent: 'Est un étudiant',
    emptyAvailabilities: "Ce candidat n'a pas réglé ses disponibilités de travail",
    otherApplication: 'Autres candidatures',

    contactCandidate: `Envoyer une demande de contact?`,
    contactNote: `L'envoi d'une demande de contact indique au candidat que vous êtes intéressé par son profil. Il pourra voir le poste et postuler. Vous allez également pouvoir voir leur profil complet s'il est préqualifié pour le poste.`,
    moreThan10years: `Plus de 10 années d'expérience directe`,
    experience: ` {{years}} années d'expérience directe`,
    addNotes: 'Nous trouvons que tu es un candidat idéal pour notre poste.',
    cancel: 'Annuler',
    sendContactRequest: 'Envoyer demande de contact',
    sendCustomMessage: 'Envoyer une demande de contact personnalisée',

    hasApplied: 'Postulé',
    accepted: 'Acceptées',
    requested: 'Demandé',
    dismissCandidate: 'Rejeter ce candidat',
    communicationCandidate: 'Envoyer un message à ce candidat',

    engageCandidateModal: {
      header: 'Vous utulisez des jetons pour ce compte',
      bodyText: '{{name}} semble être un bon candidat',
      useToken: 'Le serveur traite votre achat...',
      engage: 'Engager',
    },
    engageBtnLabel: 'Engager un candidat',
    continueBtnLabel: 'Continuer',
    sendAgainBtnLabel: 'Renvoyer',
    engageErrorText: `Vous n'êtes pas autorisé à faire cette action.`,
    sendAgainTooltipText: `Votre demande d'intérêt a été envoyée. ⏱ En attente de la réponse du candidat...`,
    engageDisableMsg: `Le chercheur n'a pas encore accepté votre demande de contact !`,
    noBookmarkedCandidates: `Vous n'avez pas de candidats sauvegardés.`,
    noReviewCandidates: `Il n'y a aucun candidat à réviser pour ce poste.`,
    noTopCandidates: `Il n'a pas de candidats pour ce poste.`,
    noActiveCandidates: "Ce poste n'a pas de candidats actifs.",
    moreThan10Years: `Plus de 10 années d'expérience directe`,
    directExperience: `{{workExperience}} années d'expérience directe`,
    moreThanExperience: `Plus de {{workExperience}} années d'expérience directe`,
    significantExperience: 'Expérience directe de {{workExperience}} ans',
    relatedExperience: 'Expérience connexe de {{workExperience}} ans',
    limitedExperienceMonths: "{{value}} mois d'expérience directe",
    limitedExperienceLessThan: "Moins de 6 mois d'expérience directe",
    limitedExperienceLabel: 'Expérience limitée',
    seekerProfile: {
      days: 'Jours',
      weeks: 'Semaines',
      immediately: 'Immédiatement',
    },
    lowTokenWarningMessage:
      'Envoyer une demande de contact utilise un de vos jetons. Les jetons sont requis pour rejoindre vos candidats, alors soyez sélectifs pour maximiser vos chances.',
    greetingHello: 'Bonjour',
    pagination: {
      showingTopResults: 'Affiche présentement {{currentItems}} sur {{totalItems}} candidats pour ce poste',
      showingBookmarkedResults: 'Affiche présentement {{currentItems}} sur {{totalItems}} candidats sauvegardés',
      showingReviewResults: `Affiche présentement {{currentItems}} sur {{totalItems}} candidats à réviser`,
      showingActiveResults: 'Affiche présentement {{currentItems}} sur {{totalItems}} candidats actifs',
    },
  },
  businessCopy: {
    createLink: 'Créer un lien de site',
    additionalParameters: 'Créer un lien pour le site avec des paramètres optionnels supplémentaires.',
    businessLink: 'Lien du site',
    additionalParams: 'Paramètres supplémentaires',
    generatedLink: `Votre lien sera généré automatiquement une fois que vous aurez cliqué sur «Créer et copier».`,
    campaign: 'Campagne',
    enterCampaign: 'Entrer la campagne',
    source: 'Source',
    enterSource: 'Entrer la source',
    medium: 'Médium',
    enterMedium: 'Entrer le médium',
    referrerId: 'Référence',
    enterReferrer: 'Entrer la référence',
    cancelBtn: 'Annuler',
    createAndCopy: 'Créer et copier',
    referrerMaxLength: 'La référence ne doit pas excéder 50 caractères.',
    sourceMaxLength: 'La source ne doit pas excéder 100 caractères.',
    campaignMaxLength: 'La campagne ne doit pas excéder 100 caractères.',
    mediumMaxLength: 'Le médium ne doit pas excéder 100 caractères.',
  },
  businessTypeFilter: {
    followed: 'Suivi',
    watched: 'Regardé',
    all: 'Tout',
    followAndWatch: 'Suivi et observé',
  },
};
